import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProductBenefitComponent } from './product-benefit.component';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    ProductBenefitComponent
  ],
  providers: [
  ],
  declarations: [
    ProductBenefitComponent
  ]
})
export class ProductBenefitModule { }
